import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "axios";
import SuccessModal from "../../utils/SuccessModal";
import { useNavigate } from "react-router-dom";
import ErrorModal from "../../utils/ErrorModal";
import ItemCount from "../../utils/ItemCount";
import Rfqs from "./Rfqs";

const MyRFQs = () => {
  const [rfq, setRfq] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState(
    localStorage.getItem("activeTab") || "INBIDDING"
  );
  const [vendor, setVendor] = useState();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [errorMsg, setErrorMsg] = useState();
  const [buyerCount, setBuyerCount] = useState(0);
  const [invitedCount, setInvitedCount] = useState(0);
  const [inCount, setInCount] = useState(0);
  const [postCount, setPostCount] = useState(0);

  useEffect(() => {
    if (!vendor) return;
    const getInbiddingCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor-rfq/count?vendorId=${vendor.vendorId}&status=INBIDDING`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setInCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getInbiddingCount();

    const getPostCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor-rfq/count?vendorId=${vendor.vendorId}&status=POSTBIDDING`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setPostCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getPostCount();

    const getBuyersCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor-rfq/count?vendorId=${vendor.vendorId}&status=BUYERS`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setBuyerCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getBuyersCount();

    const getInvitationsCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor-rfq/count?vendorId=${vendor.vendorId}&status=INVITED`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setInvitedCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getInvitationsCount();
    localStorage.removeItem("activeTab");
  }, [vendor]);

  const handleClose = () => {
    setOpen(false);
    setOpenError(false);
    setErrorMsg("");
  };

  useEffect(() => {
    const getVendor = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor?email=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        if (!res.data.name || !res.data.firmName || !res.data.pan) {
          navigate("/vendor/details");
        }
        localStorage.setItem("vendor", JSON.stringify(res.data.vendorId));
        setVendor(res.data);
      } catch (error) {
        console.log(error);
        navigate("/");
      }
    };
    getVendor();
  }, []);

  const getRFQs = async () => {
    if (!vendor) return;
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-rfq?vendorId=${vendor.vendorId}&status=${status}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setRfq(res.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getRFQs();
  }, [vendor, status]);

  return (
    <div>
      <Typography variant="h5">My RFQ</Typography>
      <Box className="dashboard-container">
        <Box
          sx={{
            display: "flex",
            gap: 1,
            pt: 2,
            borderBottom: "1px solid #dedede",
          }}
        >
          <Button
            className={`dashboard-btns ${
              status === "INBIDDING" ? "active" : ""
            }`}
            sx={{ fontSize: "10px" }}
            onClick={() => {
              setStatus("INBIDDING");
              setIsLoading(true);
              localStorage.setItem("activeTab", "INBIDDING");
            }}
          >
            In RFQ
            <ItemCount count={inCount} />
          </Button>
          <Button
            className={`dashboard-btns ${
              status === "POSTBIDDING" ? "active" : ""
            }`}
            sx={{ fontSize: "10px" }}
            onClick={() => {
              setStatus("POSTBIDDING");
              setIsLoading(true);
              localStorage.setItem("activeTab", "POSTBIDDING");
            }}
          >
            Post RFQ
            <ItemCount count={postCount} />
          </Button>
          <Button
            className={`dashboard-btns ${status === "BUYERS" ? "active" : ""}`}
            sx={{ fontSize: "10px" }}
            onClick={() => {
              setIsLoading(true);
              setStatus("BUYERS");
              localStorage.setItem("activeTab", "BUYERS");
            }}
          >
            RFQ Invites
            <ItemCount count={buyerCount} />
          </Button>
          <Button
            className={`dashboard-btns ${status === "INVITED" ? "active" : ""}`}
            sx={{ fontSize: "10px" }}
            onClick={() => {
              setIsLoading(true);
              setStatus("INVITED");
              localStorage.setItem("activeTab", "INVITED");
            }}
          >
            Invitations
            <ItemCount count={invitedCount} />
          </Button>
        </Box>
        <Rfqs
          rfq={rfq}
          isLoading={isLoading}
          activeTab={status}
          getRFQs={getRFQs}
        />
      </Box>

      <SuccessModal
        open={open}
        handleClose={handleClose}
        msg={"Tender Shortlisted!"}
      />

      <ErrorModal open={openError} handleClose={handleClose} msg={errorMsg} />
    </div>
  );
};

export default MyRFQs;